import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useEnableMemberStreakBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.enableMemberStreakBadge,
  {
    mutationKey: ['enableMemberStreakBadge'],
  },
)
